/* eslint-disable max-len */
import React, { HTMLProps } from 'react';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { CreditCardFilled } from '@ant-design/icons';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Text } from '~/components/Typo/Typo';
import { FontWeight, TextVariants } from '~/theme/constants';
import TextField from '~/components/fields/TextField/TextField';
import Button from '~/components/Button/Button';

import './OtpForm.scss';

export interface OtpFormProps extends HTMLProps<HTMLFormElement> {
  handleSubmit: (values: any) => void;
  selectedItem?: number;
  loading?: boolean;
}

const OtpForm: React.FC<OtpFormProps> = ({ handleSubmit, loading }) => {
  const { t } = useTranslation();

  const validate = Yup.object({
    otp: Yup.string().required(t('otpForm:otpCodeRequired')),
  });

  return (
    <div className="otp-payment-form">
      <div className={cn('caption-wrapper')}>
        <Text className="caption" size="s" weight={FontWeight.MEDIUM} variant={TextVariants.PRIMARY}>
          {t('otpForm:enterOtpCodeReceived')}
        </Text>
      </div>
      <div className="form-wrapper">
        <Formik
          onSubmit={values => {
            handleSubmit(values);
          }}
          initialValues={{
            otp: '',
          }}
          enableReinitialize
          validationSchema={validate}
        >
          {() => (
            <Form>
              <TextField
                name="otp"
                type="number"
                className="text-field-card-form"
                label={t('otpForm:otpCode')}
                placeholder={t('otpForm:otpCode')}
                suffixIcon={<CreditCardFilled className="suffix-icon" />}
                height={30}
                disabled={loading}
              />
              <div className="submit-button-wrapper">
                <Button
                  title={t('otpForm:send')}
                  size="block"
                  rounded
                  type="submit"
                  disabled={loading}
                  loading={loading}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default OtpForm;
